import { USE_COMPETITIONS, UseCompetitionsType } from '@/constants/licenses'

export const ADD_LICENSE_FORM_DIALOG_TITLE = 'Add License'

export const COMPETITIONS = {
  SELECT_ALL: 'License Covers All',
  COVER_SELECTED: 'Select Covered Competitions',
  EXCLUDE_SELECTED: 'Covers All Except Selected'
} as const

export type CompetitionsSelectType = ValueOf<typeof COMPETITIONS>

export const USE_ALL_COMPETITIONS_MAP = {
  [COMPETITIONS.SELECT_ALL]: USE_COMPETITIONS.ALL,
  [COMPETITIONS.COVER_SELECTED]: USE_COMPETITIONS.PARTIAL,
  [COMPETITIONS.EXCLUDE_SELECTED]: USE_COMPETITIONS.PARTIAL
} as const satisfies Record<CompetitionsSelectType, UseCompetitionsType>
